module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.rankView),
      expression: "!rankView"
    }],
    staticClass: "layout-container"
  }, [_c('div', {
    staticClass: "layout",
    class: {
      'game-over': _vm.gameOver
    }
  }, _vm._l((_vm.layout), function(row, rowIndex) {
    return _c('div', {
      staticClass: "layout-row"
    }, _vm._l((row), function(cell, cellIndex) {
      return _c('div', {
        staticClass: "layout-cell",
        class: _vm.layoutColor[rowIndex][cellIndex]
      })
    }))
  })), _vm._v(" "), _c('div', {
    staticClass: "layout-right"
  }, [_c('div', {
    staticClass: "best-score"
  }, [_c('span', [_vm._v("BEST")]), _vm._v("\n        " + _vm._s(this.bestScore) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "current-score"
  }, [_c('span', [_vm._v("SCORE")]), _vm._v("\n        " + _vm._s(this.currentScore) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "clear-line"
  }, [_c('span', [_vm._v("LINE")]), _vm._v("\n        " + _vm._s(this.clearLine) + "\n      ")]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.rankView),
      expression: "!rankView"
    }],
    staticClass: "control"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rankView),
      expression: "rankView"
    }],
    staticClass: "rank-view"
  }, [_c('div', {
    staticClass: "rank-container"
  }, [_vm._m(3), _vm._v(" "), _vm._l((this.globalScore), function(item) {
    return _c('div', {
      staticClass: "person"
    }, [_c('div', {
      staticClass: "score"
    }, [_vm._v("\n          " + _vm._s(item.score) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "line"
    }, [_vm._v("\n          " + _vm._s(item.line) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "string"
    }, [_vm._v("\n          " + _vm._s(item.string) + "\n        ")])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "rank-view-close"
  }, [_vm._v("\n      X\n    ")])]), _vm._v(" "), _c('audio', {
    staticClass: "audio-down",
    attrs: {
      "src": "./dist/down.mov"
    }
  }), _vm._v(" "), _c('audio', {
    staticClass: "audio-clear",
    attrs: {
      "src": "./dist/clear.mov"
    }
  }), _vm._v(" "), _c('audio', {
    staticClass: "audio-over",
    attrs: {
      "src": "./dist/over.mov"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "globale-score"
  }, [_c('span', [_vm._v("PAUSE")]), _vm._v("\n        RANK\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-left"
  }, [_c('div', {
    staticClass: "button rotate-button"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-right"
  }, [_c('div', {
    staticClass: "drop"
  }, [_c('div', {
    staticClass: "button drop-button"
  })]), _vm._v(" "), _c('div', {
    staticClass: "left-right"
  }, [_c('div', {
    staticClass: "button left-button"
  }), _vm._v(" "), _c('div', {
    staticClass: "button right-button"
  })]), _vm._v(" "), _c('div', {
    staticClass: "down"
  }, [_c('div', {
    staticClass: "button down-button"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "person"
  }, [_c('div', {
    staticClass: "score"
  }, [_vm._v("\n          Score\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_vm._v("\n          Line\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "string"
  }, [_vm._v("\n          Player\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-085fe1d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 53
// module chunks = 0